export default {
  bind(el, binding) {
    el.addEventListener("keypress", event => {
      if (!binding.value) {
        return;
      }

      if (el.value.length >= binding.value) {
        event.preventDefault();
      }
    });
  },
};
